import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider, Store} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './components/app';
import Notification from './components/common/notification/notification';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import registerServiceWorker from './registerServiceWorker';

import {container, TYPES} from './utils/inversify-config';
import './utils/container-bootstrap';
import MiranaState from './reduxstore/mirana-state';
import MiranaServiceClient from './middleware/mirana-client';
import {setIsAuthenticated, setIsLoading, setUserDetails} from './reduxstore/actions/action-creators';
import ScrollToTop from './theme/app/ScrollToTop';
import {ACCESS_TOKEN} from './utils/constants';
import * as moment from 'moment';
import 'moment/locale/es';

registerPlugin(FilePondPluginFileValidateType);

const store = container.get<Store<MiranaState>>(TYPES.REDUX_STORE);

const appClient = container.get<MiranaServiceClient>(TYPES.MIRANA_SERVICE);

store.dispatch(setIsLoading(true));

async function autenticarUsuario() {
    if (localStorage.getItem(ACCESS_TOKEN)) {
        try {
            const response = await appClient.getCurrentUser();
            store.dispatch(setUserDetails(response));
            store.dispatch(setIsAuthenticated(true));
        } catch (ex) {
            localStorage.removeItem(ACCESS_TOKEN);
            store.dispatch(setIsAuthenticated(false));
        }
    } else {
        store.dispatch(setIsAuthenticated(false));
    }
    store.dispatch(setIsLoading(false));
}

setTimeout(() => {
    autenticarUsuario();
}, 1500);


moment.locale('es');

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename='/'>
            <ScrollToTop>
                <Notification/>
                <App/>
            </ScrollToTop>
        </BrowserRouter>
    </Provider>,
    document.getElementById('mirana-client') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx